import styled from "styled-components";

const LogoImg = styled.img`
  width: 100%;
  z-index: -1;
`;

export default LogoImg;
